<template>
	<layout-admin-form class="app-admin admin-watch-form" :action="action">
		<div slot="breadcrumbs"><admin-breadcrumbs :breadcrumbs="breadcrumbs"/></div>
		<span slot="header">{{ title }}</span>
		<spinner v-if="loading"/>
		<error-box v-else-if="error" :error="error"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-text v-model="model.name" name="service_name" placeholder="Name" rules="required"/>
			<input-text v-model="model.description" name="service_description" placeholder="Description" rules="required"/>

			<section class="c-group">
				<header>
					<h1>Monthly</h1>
				</header>
				<main>
					<input-text v-model="model.monthly_price_base_unity" name="service_monthly_price_base_unity" placeholder="Price base by unity" rules="required|decimal:2|min_value:0"/>
					<input-text v-model="model.monthly_tax_unity" name="service_monthly_tax_unity" placeholder="Tax by unity" rules="required|decimal:2|min_value:0"/>
					<input-text v-model="model.monthly_price_unity" name="service_monthly_price_unity" placeholder="Price by unity" rules="required|decimal:2|min_value:0"/>
				</main>
			</section>

			<section class="c-group">
				<header>
					<h1>Yearly</h1>
				</header>
				<main>
					<input-text v-model="model.yearly_price_base_unity" name="service_yearly_price_base_unity" placeholder="Price base by unity" rules="required|decimal:2|min_value:0"/>
					<input-text v-model="model.yearly_tax_unity" name="service_yearly_tax_unity" placeholder="Tax by unity" rules="required|decimal:2|min_value:0"/>
					<input-text v-model="model.yearly_price_unity" name="service_yearly_price_unity" placeholder="Price by unity" rules="required|decimal:2|min_value:0"/>
				</main>
			</section>

			<section class="c-group">
				<header>
					<h1>Tax</h1>
				</header>
				<main>
					<input-text v-model="model.tax_percent" name="service_tax_percent" placeholder="Tax percent" rules="required|decimal:2|min_value:0"/>
					<input-text v-model="model.tax_percent_label" name="service_tax_percent_label" placeholder="Tax percent label" rules="required"/>
				</main>
			</section>

			<input-toggle v-model="model.visible" name="service_visible" placeholder="Visible" rules="required"/>
			<error-box v-if="form_error" :error="form_error"/>
			<button type="submit" class="btn btn-primary btn-round">Save</button>
		</form>
	</layout-admin-form>
</template>

<script>
import LayoutAdminForm from '../LayoutAdminForm'
import AdminBreadcrumbs from '../AdminBreadcrumbs'
export default {
	components: {
		LayoutAdminForm,
		AdminBreadcrumbs
	},
	props: [
		'service_id',
		'data',
		'action'
	],
	data () {
		return {
			title: 'Service',
			loading: false,
			error: null,
			form_error: null,
			model: {
				name: '',
				description: '',
				monthly_price_base_unity: '',
				monthly_price_unity: '',
				monthly_tax_unity: '',

				yearly_price_base_unity: '',
				yearly_price_unity: '',
				yearly_tax_unity: '',

				tax_percent: '0.23',
				tax_percent_label: '23%',

				visible: true
			}
		}
	},
	computed: {
		breadcrumbs () {
			return [
				{
					title: 'Service List',
					name: 'AdminServiceList'
				},
				{
					title: `${this.action} ${this.title}`
				}
			]
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.submit()
			})
		},
		submit () {
			switch (this.action) {
				case 'add':
					this.addService()
					break
				case 'edit':
					this.editService()
					break
				default:
					this.$log.warn('admin', 'action not set')()
			}
		},
		getService () {
			this.loading = true
			this.$api.subscriptions.services.admin.getById(this, this.service_id)
				.then(response => {
					this.$log.info('admin', 'subscriptions.services.admin.getById OK', response)()
					this.model = response.body
				})
				.catch(error => {
					this.$log.error('admin', 'subscriptions.services.admin.getById ERROR', error)()
					this.error = error
				})
				.finally(() => {
					this.loading = false
				})
		},
		addService () {
			this.$api.subscriptions.services.admin.add(this, this.model)
				.then(response => {
					this.$log.info('admin', 'subscriptions.services.admin.add OK', response)()
					this.$router.push({ name: 'AdminServiceList' })
				})
				.catch(error => {
					this.$log.error('admin', 'subscriptions.services.admin.add ERROR',error)()
					this.form_error = errors
				})
		},
		editService () {
			this.$api.subscriptions.services.admin.editById(this, this.service_id, this.model)
				.then(response => {
					this.$log.info('admin', 'subscriptions.services.admin.editById OK', response)()
					this.$router.push({ name: 'AdminServiceList' })
				})
				.catch(error => {
					this.$log.error('admin', 'subscriptions.services.admin.editById ERROR', error)()
					this.form_error = error
				})
		}
	},
	mounted () {
		if (this.action === 'edit') {
			if (this.data === undefined) {
				this.getService()
			} else {
				this.model = this.data
			}
		}
	}
}
</script>

<style scoped>
.c-group {
	border: 1px solid var(--main-color);
	border-radius: 5px;
	margin: 10px 0;
}
.c-group > header {
	padding: 10px;
	background-color: var(--main-color);
}
.c-group > header > h1 {
	margin: 0;
	color: #fff;
	text-transform: uppercase;
	font-size: 14px;
	font-weight: 700;
}
.c-group > main {
	display: flex;
	flex-direction: row;
	padding: 10px 0;
}
.c-group > main > div {
	flex: 1;
	margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/services/ServiceForm.vue